import { Flex, Flexed, Input, MainWrap, PhoneNumber, Wrap } from '../../utilities/Shared';
import { useEffect, useState, useMemo } from 'react';
import { MdDelete } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { sortit, sortnum, sortsalesreps, sortcsrreps, sortdate, sortfollowdate } from '../../utilities/Sort';
import { Edit } from 'lucide-react';
import Editfollow from './Editfollow';
import Modal from '../../modals/Modal';

const SalesCustomerPanel = ({ vendorlist, search, reset, setReset, order, rowclass, setOrder, setList }) => {
  const nav = useNavigate();
  const [newlist, setNewlist] = useState(vendorlist);
  const [editfollo, setEditfollo] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [hasLocalUpdates, setHasLocalUpdates] = useState(false);
  const [loading, setLoading] = useState(false);
  const today = new Date()

  useEffect(() => {
    if (!hasLocalUpdates) {
      console.log('Resetting newlist with vendorlist:', vendorlist);
      setNewlist(vendorlist);
    }
  }, [vendorlist, reset, hasLocalUpdates]);

  // Function to update customer in newlist and sync customer state
  const updateCustomerList = (updatedCustomer) => {
    setLoading(true);
    console.log('Updating newlist with customer:', updatedCustomer);
    setNewlist((prevList) => {
      const newList = [...prevList];
      const index = newList.findIndex((item) => item._id === updatedCustomer._id);
      if (index !== -1) {
        newList[index] = updatedCustomer;
      }
      return newList;
    });
    setCustomer(updatedCustomer);
    setHasLocalUpdates(true);
    setTimeout(() => {
      setLoading(false);
      console.log('Newlist update complete:', newlist);
    }, 100); // Simulate async update delay
  };

  // Get the latest customer from newlist when opening the modal
  const handleOpenEditModal = (selectedCustomer) => {
    if (loading) {
      console.log('Waiting for newlist update before opening modal');
      return;
    }
    const latestCustomer = newlist.find((item) => item._id === selectedCustomer._id) || selectedCustomer;
    console.log('Opening modal with customer:', latestCustomer);
    setCustomer(latestCustomer);
    setEditfollo(true);
  };

  const filteredList = useMemo(() => {
    return newlist?.filter((item) =>
      search.toLowerCase() === ''
        ? item
        : item.name?.toLowerCase().includes(search.toLowerCase()) ||
          item.company_id?.toString().includes(search) ||
          item.dba?.toLowerCase().includes(search)
    );
  }, [newlist, search]);


  const compareDateToToday = (followupDate) => {
    const today = new Date();
    if (!followupDate) return false;
    const date = new Date(followupDate);
    if (isNaN(date.getTime())) return false;
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  };




  return (
    <>
      {loading && (
        <Flexed style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000 }}>
          <div style={{
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #3498db',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            animation: 'spin 1s linear infinite',
          }} />
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </Flexed>
      )}
      <Modal
        show={editfollo && !loading}
        headerbgcolor="#8498AC"
        width="75%"
        headercolor="#144259"
        header="Edit Followup"
        onCancel={() => setEditfollo(false)}
        key={customer?._id}
      >
        <Editfollow
          onCancel={() => setEditfollo(false)}
          customer={customer}
          setCustomer={setCustomer}
          reset={reset}
          setReset={setReset}
          updateCustomerList={updateCustomerList}
        />
      </Modal>
      <Flexed
        style={{ borderBottom: '1px solid black', padding: '4px', background: '#8398AB', color: 'white', marginBottom: '5px' }}
        className="hand"
      >
        <Flex flex="1.5" onClick={() => sortit('name', order, newlist, setNewlist, setOrder)}>
          Customer
        </Flex>
        <Flex>Contact</Flex>
        <Flex flex="2">Email</Flex>
        <Flex>Phone</Flex>
        <Flex onClick={() => sortfollowdate('followup', order, newlist, setNewlist, setOrder)}>Follow Date</Flex>
        <Flex flex="3" >
          Note
        </Flex>
        <Flex flex=".1"> </Flex>
      </Flexed>
      {filteredList?.map((customer, index) => (
        <Flexed
          className="normalrow"
          key={index}
          margin="0"
          borderBottom="1px solid lightgrey"
        >
          <Flex className="" flex="1.5" onClick={() => nav(`/customers/customer/${customer._id}`)}>
            {customer.name}
          </Flex>
          <Flex className="">{customer.followup[customer.followup?.length - 1]?.name || ''}</Flex>
          <Flex
            flex="2"
            className=""
            onClick={() => customer.followup[customer.followup?.length - 1]?.email && (window.location = `mailto:${customer.followup[customer.followup?.length - 1].email}`)}
          >
            {customer.followup[customer.followup?.length - 1]?.email || ''}
          </Flex>
          <Flex className="">{PhoneNumber(customer.followup[customer.followup?.length - 1]?.phone) || ''}</Flex>
          <Flex className="" style={{fontWeight:compareDateToToday(customer.followup[customer.followup?.length - 1]?.date) ? "bold" : "normal",fontSize:compareDateToToday(customer.followup?.date) ? "1.3rem" : "",color:compareDateToToday(customer.followup?.date) ? "rgb(255,0,0,.68)" : "inherit"}}>
            {customer.followup[customer.followup?.length - 1]?.date ? new Date(customer.followup[customer.followup?.length - 1].date).toLocaleDateString() : ''}
          </Flex>
          <Flex
            flex="3"
            className=""
            style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {customer.followup[customer.followup?.length - 1]?.note || ''}
          </Flex>
          <Flex flex=".1">
            <Edit
              size="16"
              aria-label="Edit follow-up"
              onClick={() => handleOpenEditModal(customer)}
            />
          </Flex>
        </Flexed>
      ))}
    </>
  );
};

export default SalesCustomerPanel;